import { useState, useCallback } from "react"
import queryString from "query-string"
import { useLocation } from "react-router"

export default function useQueryString(defaults = {}) {
  const { search, pathname } = useLocation()
  const [parsedParams, setParams] = useState(() => ({
    ...defaults,
    ...queryString.parse(search, {
      parseBooleans: true,
      parseNumbers: true,
    }),
  }))

  const setQueryString = useCallback(
    (params) => {
      const qs = queryString.stringify(params)
      const location = [pathname, qs].filter((i) => i).join("?")

      setParams(params)
      window.history.replaceState(params, new Date().getTime(), location)
    },
    [setParams, pathname],
  )

  return [parsedParams, setQueryString]
}
